import React, { Component } from 'react';
import Crumbs from './../../../Crumbs/Crumbs';
import createHistory from 'history/createHashHistory';
import { connect } from "react-redux"//联系store的组件
import evn from "./../../../../../actions/index"//action的所有事件
import "./../../../Common/CaseDetailsInfo.css"//引入样式
import CaseDetailsInfo from "./../../../Common/CaseDetailsInfo.js"//引入组件

import $ from "jquery"

import { Form, Row, Col, Input, Button, message, Select, Upload, Icon, InputNumber, Tooltip } from 'antd';
import "./../style.css";
import { data_Url,Hcurl } from "./../../../../../constants/index";//获取公共路径
import EventSet from "./../../../../../assets/PubJs/hcPub";//公用的所有事件
const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;
const history = createHistory();
let _transact = null;
let timeout;
let currentValue;//办理部门
//var localValue = JSON.parse(localStorage.getItem('userInfo'));
var cid = EventSet.getQueryString('cid');//登记单ID
var userIp = localStorage.getItem('userIp');
//console.log(userIp, 'userIp');
var comcode = '';//企业code
var CI_Code = '';//登记单编号
var record={};
var cont1 = "您好，您的投诉已经处理完毕，请对处理情况进行评价，直接回复数字：1满意，2基本满意，3不满意;不回复视为满意。您也可在智慧315平台直接进行评价，谢谢。"
class App extends Component {
    state = {
        autoHeight: "",
        isShow: "block",
        True: false,
        locationValue: "",//CI_Code
        comCode: "",//企业code
        dataName: '',
        fileList: [],
        HeaderName: [],//负责人
        HanderName: [],//经办人
        GovDepartCode: "",//企业直属部门code
        UserPhone: "",//提供方电话号码
        disabled: false,
        neirong: "和解内容"
    }
    autoHeight = () => {  //内容区域高度自适应
        let autoHeight = window.innerHeight - 429;
        this.setState({
            autoHeight: autoHeight
        })
    }
    //获取负责人姓名、电话
    getTransact = () => {
        $.ajax({
            url: Hcurl + "/Business/GetComCodePhone?ComCode=" + comcode,
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                _transact.GetComCode()
                //console.log(data, '获取企业负责人')
                if (data.length !== 0 && data !== null) {
                    _transact.props.form.setFieldsValue({
                        CP_HeaderName: data[0].CU_UserName,
                        CP_HeaderPhone: data[0].CU_LinkPhone
                    })

                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                //console.log(data)
            }
        })
    }

    //获取企业直属部门
    GetComCode = () => {
        $.ajax({
            url: Hcurl + "/Business/GetCom_GovDepartCode?Com_Code=" + comcode,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                //console.log(data, 'datasadasdasd')
                if (data !== '' && data !== null) {
                    _transact.setState({
                        GovDepartCode: data
                    })
                };
                _transact.GetUserPhone();
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data)
            }
        })

    }
    getjingban = () => {
        $.ajax({
            url: Hcurl + "/user/GetUserInfo",
            type: "post",
                                            headers: {
                                                "token": EventSet.getUserInfo()['token']
                                            },
            data: {
                CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code
            },
            headers: {
                token: JSON.parse(localStorage.getItem("userInfo")).token
            },
            async: false,
            success: function (res) {
                _transact.props.form.setFieldsValue({
                    CP_HanderPhone: JSON.parse(res).linkPhone,
                    CP_HanderName: JSON.parse(res).userName,
                })
            },
            error: function (res) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                //history.push({ pathname: '/Login/LoginMain/LoginEntry', })
            }
        })
    }
    // 获取提供方电话
    GetUserPhone = () => {
        $.ajax({
            url: Hcurl + "/Business/GetUSERPHONE?CI_Code=" + _transact.state.locationValue,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                console.log(data, '获取提供方电话');
                if (data != '' & data != null) {
                    _transact.setState({
                        UserPhone: data
                    })
                }
            },
            error: function (res) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                //history.push({ pathname: '/Login/LoginMain/LoginEntry', })
            }
        })
    }

    componentWillMount() {
        comcode = EventSet.getQueryString('CI_DealDeapartCode');
        //console.log(comcode, 'comcode');
        CI_Code = EventSet.getQueryString('CI_Code');
        //console.log(CI_Code, 'CI_CodeCI_CodeCI_Code');
        record=JSON.parse(sessionStorage.getItem('record_'+CI_Code));
    }
    componentDidMount() {
        _transact = this;
        //console.log(comcode, 'comcodecomcodecomcode');
        this.setState({
            locationValue: decodeURI(CI_Code),//登记单编号
            comCode: decodeURI(comcode),//企业code
        })
        //this.props.form.setFieldsValue({
        //    CP_HanderName: EventSet.getUserInfo().userName,
        //    CP_HanderPhone: EventSet.getUserInfo().linkPhone,
        //})
        this.getjingban();
        setTimeout(() => {
            _transact.getTransact();
        }, 200)

        this.autoHeight();

        this.props.form.setFieldsValue({
            infoMessage: "您好，您登记的" + EventSet.getQueryString('CI_Code') + "的投诉," + record.Com_Name + "依据投诉情况已与您达成和解，详细情况可以登录\"智慧315平台\"进行查询。"
        })

    }

    //短信通知选择方法
    onOptionChange2 = (value) => {
        this.props.form.setFieldsValue({
            info: value
        })
        if (value === '否') {
            if (this.props.form.getFieldValue('infoMessage') === '') {
                this.props.form.setFieldsValue({
                    infoMessage: null
                })
            }
            this.setState({
                isShow: 'none',
                True: false
            })
        } else {
            console.log(value);
            if (this.props.form.getFieldValue('infoMessage') == null) {
                this.props.form.setFieldsValue({
                    infoMessage: ""
                })
            }
            this.setState({
                isShow: 'block',
                True: true
            })
        }
    }
    handleSubmit = (e) => {  //确定反馈按钮
        history.location.search.split('CI_Code=')[1]
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                message.warning('请检查后重新尝试')
                return;
            }
            let imageUrl = '';
            $.each(this.state.fileList, function (ids, txt) {
                if (typeof (txt.url) != 'undefined' && txt.url != 'undefined')
                    imageUrl += txt.url + ';';
            })
            imageUrl = imageUrl.substring(0, imageUrl.length - 1);
            //console.log('imageUrl', imageUrl);
            const { ...values } = fieldsValue;
            //console.log(values)
            $.ajax({
                url: Hcurl + '/Business/BusinessPending',
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                data: {
                    CI_Code: _transact.state.locationValue,
                    ModuleId: "",//传空
                    UserCode: EventSet.getUserInfo().CU_Code,
                    CI_DealDeapartCode: _transact.state.GovDepartCode,//企业的直属部门
                    UserIp: userIp,
                    UserName: EventSet.getUserInfo().userName,
                    CP_Result: values.CP_Result,
                    CP_Attachs: imageUrl,
                    CP_Content: values.CP_Content,
                    CP_HanderName: values.CP_HanderName,
                    CP_HanderPhone: values.CP_HanderPhone,
                    CP_HeaderName: values.CP_HeaderName,
                    CP_HeaderPhone: values.CP_HeaderPhone,
                    Com_Code: _transact.state.comCode,
                    ApplyMediation: "",//是否申请调解传空
                    CP_RedeemLoss: values.CP_RedeemLoss,
                    CP_DisputeMoney: values.CP_DisputeMoney
                },
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    //console.log(data)
                    if (data.indexOf('|') >= 0) {
                        if (data.split('|')[0] == "true") {
                            _transact.setState({
                                disabled: true
                            })
                            message.success(data.split('|')[1]);
                            if (values.CP_Result == '和解成功') {

                                // $.ajax({
                                //     url: data_Url + 'WisdomAPI.ashx',
                                //     //url: "http://localhost:5113/ashx/WisdomAPI.ashx",
                                //     type: "post",
                                //     headers: {
                                //         "token": EventSet.getUserInfo()['token']
                                //     },
                                //     dataType: "jsonp",
                                //     jsonp: "callback",
                                //     jsonpCallback: "successcallback",
                                //     data: {
                                //         doType: "SendTemplateMessage",
                                //         CIID: EventSet.getQueryString('cid'),
                                //         tele: _transact.state.UserPhone,
                                //         msg: "",
                                //         templateCode: "20171202019",
                                //         isPostWxMessage: 0,
                                //         UserName: EventSet.getUserInfo().userName,
                                //         UserCode: EventSet.getUserInfo().CU_Code,
                                //         IP: userIp,
                                //         userType: 2,//企业传2，部门传1
                                //     },
                                //     success: function (data) {
                                //         console.log(data);
                                //     },
                                //     error: function (data) {
                                //         console.log(data);
                                //     }
                                // })
                            }
                            setTimeout(() => {
                                console.log(_transact.props.form.getFieldValue('info'), values, values.CP_Result, 'asdasd');
                                if (_transact.props.form.getFieldValue('info') === '是') {
                                    console.log('测试0')
                                    if (values.CP_Result == '和解成功') {
                                        // console.log('测试1')
                                        // $.ajax({
                                        //     url: data_Url + 'WisdomAPI.ashx',
                                        //     //url: "http://localhost:5113/ashx/WisdomAPI.ashx",
                                        //     type: "post",
                                        //     headers: {
                                        //         "token": EventSet.getUserInfo()['token']
                                        //     },
                                        //     dataType: "jsonp",
                                        //     jsonp: "callback",
                                        //     jsonpCallback: "successcallback",
                                        //     data: {
                                        //         doType: "SendTemplateMessage",
                                        //         CIID: EventSet.getQueryString('cid'),
                                        //         tele: _transact.state.UserPhone,
                                        //         msg: _transact.props.form.getFieldValue('infoMessage'),
                                        //         templateCode: "20171202028",
                                        //         isPostWxMessage: 1,
                                        //         UserName: EventSet.getUserInfo().userName,
                                        //         UserCode: EventSet.getUserInfo().CU_Code,
                                        //         IP: userIp,
                                        //         userType: 2,//企业传2，部门传1
                                        //     },
                                        //     success: function (data) {
                                        //         console.log(data, EventSet.getQueryString('cid'), _transact.props.form.getFieldValue('infoMessage'), '选择是且和解成功success');
                                        //     },
                                        //     error: function (data) {
                                        //         console.log(data, EventSet.getQueryString('cid'), _transact.props.form.getFieldValue('infoMessage'), '选择是且和解成功error');
                                        //     }
                                        // })
                                    } else {
                                        // console.log('测试2')
                                        // $.ajax({
                                        //     url: data_Url + 'WisdomAPI.ashx',
                                        //     //url: "http://localhost:5113/ashx/WisdomAPI.ashx",
                                        //     type: "post",
                                        //     headers: {
                                        //         "token": EventSet.getUserInfo()['token']
                                        //     },
                                        //     dataType: "jsonp",
                                        //     jsonp: "callback",
                                        //     jsonpCallback: "successcallback",
                                        //     data: {
                                        //         doType: "SendTemplateMessage",
                                        //         CIID: EventSet.getQueryString('cid'),
                                        //         tele: _transact.state.UserPhone,
                                        //         msg: _transact.props.form.getFieldValue('infoMessage'),
                                        //         templateCode: "20171202029",
                                        //         isPostWxMessage: 1,
                                        //         UserName: EventSet.getUserInfo().userName,
                                        //         UserCode: EventSet.getUserInfo().CU_Code,
                                        //         IP: userIp,
                                        //         userType: 2,//企业传2，部门传1
                                        //     },
                                        //     success: function (data) {
                                        //         console.log(data, EventSet.getQueryString('cid'), _transact.props.form.getFieldValue('infoMessage'), '选择是且和解失败success');
                                        //     },
                                        //     error: function () {
                                        //         console.log(data, EventSet.getQueryString('cid'), _transact.props.form.getFieldValue('infoMessage'), '选择是且和解失败error');
                                        //     }
                                        // })
                                    }
                                }
                            }, 1200);
                            setTimeout(() => {
                                _transact.returnPrv();
                            }, 1500)
                        } else {
                            message.warn(data.split('|')[1]);

                        }

                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    //console.log(data)
                }
            })
        })
    }
    returnPrv = () => {  //返回上一页
        history.push({
            pathname: '/Content/Business/CompromiseListWait',
        })
    }

    //上传文件
    handleChange = (info) => {  //文件上传方法
        this.setState({
            dataName: info.file.name
        })
        let fileList = info.fileList;
        // if(info.file.type.search("image/") == '-1'){
        //     message.error(`文件${info.file.name} 不是合法的图片格式`);
        //     return false
        // }else 
        if (info.file.status === 'done') {
            message.success(`${info.file.name} 文件上传成功`);

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 文件上传失败`);
        }
        fileList = fileList.map((file) => {
            if (file.response) {
                file.url = file.response;
            }
            return file;
        });
        fileList = fileList.filter((file) => {
            if (file.size < 20971520) {
                return true;
            } else
                return false;
        });
        this.setState({
            fileList
        })
        //console.log('fileList1111', this.state.fileList);
    }

    beforeUpload = (file) => {
        console.log(file)
        
        return new Promise((resolve, reject)=>{
            const isLt2M = file.size / 1024 / 1024 < 20;
            if(file.type.search("image/") == '-1'){
                message.error(`文件${file.name} 不是合法的图片格式`);
                reject()
            }else if (!isLt2M) {
                message.error('单个附件大小最多20M');
            } else {
                this.setState({ dataName: file.name })
                resolve()
            } 
        })
        // return true;
    }

    //负责人模糊匹配
    fetch(value, callback) {
        //console.log(value, 'fetch')
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        function fake() {
            $.ajax({
                url: Hcurl + "/Business/GetAllComCodePhone?ComCode=" + _transact.state.comCode + "&UserName=" + value,
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    //console.log(data, '负责人模糊匹配')
                    if (data != []) {
                        callback(data);
                    } else {
                        let data = [];
                        callback(data);
                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    console.log(data)
                }
            })
        }
        timeout = setTimeout(fake, 300);
    }
    // 负责人模糊匹配下拉框方法
    HeaderNameChange(value) {
        //console.log(value, 'value')
        _transact.props.form.setFieldsValue({
            CP_HeaderName: value!=undefined? value.replace(/'/g,''):''
        })

        if (value != undefined) {
            _transact.fetch(value, data => _transact.setState({ HeaderName: data }));
            //console.log(_transact.state.HeaderName, 'HeaderNameHeaderNameHeaderName')
        }
    }
    // 负责人模糊匹配下拉框方法
    onHeaderNameSelect = (value, option) => {
        //console.log(value, option, 'option')
        setTimeout(function () {
            _transact.props.form.setFieldsValue({
                CP_HeaderPhone: option.key
            })
        }, 20)
    }
    //经办人模糊匹配
    Jfetch(value, callback) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        currentValue = value;
        function fake() {
            $.ajax({
                url: Hcurl + "/Business/GetAllComCodePhone?ComCode=" + _transact.state.comCode + "&UserName=" + value,
                type: "post",
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (data) {
                    //console.log(data, _transact.state.comCode, value)
                    if (data != []) {
                        callback(data);
                    } else {
                        let data = [];
                        callback(data);
                    }
                },
                error: function (data) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    //console.log(data)
                }
            })
        }
        timeout = setTimeout(fake, 300);
    }
    // 经办人模糊匹配下拉框方法
    HanderNameChange(value) {
        //console.log(value, 'value')
        
        _transact.props.form.setFieldsValue({
            CP_HanderName: value!=undefined? value.replace(/'/g,''):''
        })

        if (value != undefined) {
            _transact.Jfetch(value, data => _transact.setState({ HanderName: data }));
        }
    }
    // 经办人模糊匹配下拉框方法
    HanderNameSelect = (value, option) => {
        //console.log(value, option, 'option')
        setTimeout(function () {
            _transact.props.form.setFieldsValue({
                CP_HanderPhone: option.key
            })
        }, 20)
    }

    myValidator1 = (rule, value, callback) => {
        console.log(value);
        if (value != undefined) {
            if (value.length > 20) {
                //console.log('20个字以内');
                callback('20个字以内');
                return;
            } else {
                callback();
            }
        } else {
            callback();
        }
    }

    myValidator2 = (rule, value, callback) => {
        //if (value != "") {
        //    var num = parseFloat(value)
        //    if (!isNaN(num)) {
        //        if (num.toString().length >= 15) {
        //            console.log(11)
        //            callback(rule.message);
        //        } else {
        //            callback();
        //        }
        //    } else {
        //        if (value == "") {
        //            callback();
        //        } else {
        //            callback();
        //        }
        //    }
        //} else {
        //    callback();
        //}
    }
    change = (value) => {
        this.props.form.resetFields('CP_Content');

        console.log(value)
        if (value == '和解成功') {
            this.setState({
                neirong: "和解内容"
            })
            this.props.form.setFieldsValue({
                infoMessage: "您好，您登记的" + EventSet.getQueryString('CI_Code') + "的投诉，" + record.Com_Name + "依据投诉情况已与您达成和解，详细情况可以登录\"智慧315平台\"进行查询。"
            })
        } else {
            this.setState({
                neirong: "争议内容"
            })
            this.props.form.setFieldsValue({
                infoMessage: "您好，您登记的" + EventSet.getQueryString('CI_Code') + "的投诉现企业和解失败，详细情况可以登录\"智慧315\"平台进行查询。"
            })
        }
    }
    render() {
        const { autoHeight } = this.state;
        const head = { 'X-Requested-With': null }
        const style = {
            minHeight: autoHeight
        };
        const { getFieldDecorator } = this.props.form;
        //const props = {
        //    name: 'file',
        //    action: "https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx​​",
        //    //action: Hcurl + "/CompanyCore/UploadWholeFile",
        //    data: {
        //        name: this.state.dataName
        //    },
        //    onChange: this.handleChange,
        //    beforeUpload: this.beforeUpload,
        //    onRemove: this.onRemove,
        //    multiple: true,

        //};
        const formItemLayout = {
            labelCol: {
                xxl: { span: 7 },
                xl: { span: 10 },
                lg: { span: 12 },
                md: { span: 10 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xxl: { span: 17 },
                xl: { span: 14 },
                lg: { span: 12 },
                md: { span: 14 },
                sm: { span: 14 }
            },
        };
        const formItemLayout1 = {
            labelCol: {
                xxl: { span: 4 },
                xl: { span: 6 },
                lg: { span: 5 },
                md: { span: 10 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xxl: { span: 20 },
                xl: { span: 18 },
                lg: { span: 19 },
                md: { span: 14 },
                sm: { span: 14 }
            },
        }


        return (
            <div style={style} id='Company'>
                <Crumbs title={"待和解/反馈操作"} />
                <Row className='Company' gutter={40}>
                    <div className='LFeedback'>和解反馈</div>
                    <Col span={12}>
                        <CaseDetailsInfo cid={EventSet.getQueryString('cid')} type='CompanyTransact' />
                    </Col>
                    <Col span={12} className='LFeedbackInfo'>
                        <p className='Ltitle' style={{ marginLeft: 20 }}>和解信息</p>
                        <Form>
                            <Row gutter={20}>
                                <Col span={12}>
                                    <FormItem
                                        label="和解结果"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_Result', { rules: [{ required: true, message: '请选择和解结果' }], initialValue: "和解成功" }
                                        )(
                                            <Select size='default' onChange={this.change}>
                                                <Option value="和解成功">和解成功</Option>
                                                <Option value="和解失败">和解失败</Option>
                                            </Select>
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <FormItem
                                        label="争议金额(元)"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_DisputeMoney', {
                                            rules: [{ required: true, message: '请输入争议金额' }],
                                        })(
                                            <InputNumber style={{ width: '95%' }} placeholder="单位：元" min={0.00} step={1} precision={2} max={999999999.99} parser={value => value == '' ? '0.00' : value} />
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem
                                        label="退赔金额(元)"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_RedeemLoss', { rules: [{ required: true, message: '请输入退赔金额' }], }
                                        )(

                                            //<InputNumber style={{ width: "88%" }} min={0.0} step={0.1} placeholder="单位：元" />
                                            <InputNumber style={{ width: '100%' }} placeholder="单位：元" min={0.00} step={1} precision={2} max={999999999.99} parser={value => value == '' ? '0.00' : value} />
                                            //<InputNumber style={{ width: "88%" }} min={0.0} step={0.1} precision={2} max={999999999.99}  placeholder="单位：元" />
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>


                            <Row gutter={20}>
                                <Col span={12}>
                                    <FormItem
                                        label="经办人"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_HanderName', {
                                            rules: [{ required: true, message: '请输入经办人姓名' }, { validator: this.myValidator1 }],
                                        })(

                                            <Select
                                                allowClear
                                                mode="combobox"
                                                placeholder="请输入经办人姓名"
                                                defaultActiveFirstOption={false}
                                                showArrow={false}
                                                filterOption={false}
                                                onChange={this.HanderNameChange}
                                                onSelect={this.HanderNameSelect}

                                            >
                                                {
                                                    this.state.HanderName.map(function (e) {
                                                        return <Option key={e.CU_LinkPhone} value={e.CU_UserName}>{e.CU_UserName}</Option>
                                                    })
                                                }
                                            </Select>
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem
                                        label="经办人电话"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_HanderPhone', {
                                            rules: [{ required: true, message: '请输入联系电话' }, { pattern: /^\d{6,18}$/, message: '请输入有效的联系电话' }],
                                        })(
                                            <Input placeholder="请输入联系电话" />
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col span={12}>
                                    <FormItem
                                        label="负责人"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_HeaderName', {
                                            rules: [{ required: true, message: '请输入负责人姓名' }, { validator: this.myValidator1 }],
                                        })(
                                            <Select
                                                allowClear
                                                mode="combobox"
                                                placeholder="请输入负责人姓名"
                                                defaultActiveFirstOption={false}
                                                showArrow={false}
                                                filterOption={false}
                                                onChange={this.HeaderNameChange}
                                                onSelect={this.onHeaderNameSelect}
                                            >
                                                {
                                                    this.state.HeaderName.map(function (e) {
                                                        return <Option key={e.CU_LinkPhone} value={e.CU_UserName}>{e.CU_UserName}</Option>
                                                    })
                                                }
                                            </Select>
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem
                                        label="负责人电话"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_HeaderPhone', {
                                            rules: [{ required: true, message: '请输入联系电话' }, { pattern: /^\d{6,18}$/, message: '请输入有效的联系电话' }],
                                        })(
                                            <Input placeholder="请输入联系电话" />
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row style={{ marginLeft: "-20px" }}>
                                <Col span={24}>
                                    <FormItem
                                        label={this.state.neirong}
                                        {...formItemLayout1}

                                    >
                                        {getFieldDecorator('CP_Content', {
                                            rules: [{ required: true, message: this.state.neirong == '和解内容' ? '请输入和解结果！' : '请输入争议内容！' },],
                                        }
                                        )(
                                            <TextArea autosize={{ minRows: 6, maxRows: 8 }} placeholder={this.state.neirong == '和解内容' ? '请输入详细的和解结果，1000字以内' : '请输入详细的争议内容，1000字以内'} maxLength='1000' />
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <FormItem
                                        label="附件上传"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('CP_Attachs'
                                        )(

                                            (this.state.fileList != null && this.state.fileList.length >= 4) ? <Upload
                                                name="file"
                                                action="https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"
                                                onChange={this.handleChange}
                                                beforeUpload={this.beforeUpload}
                                                fileList={this.state.fileList}
                                                headers={head}
                                         
                                            ><Button disabled={true}>
                                                    <Icon type="upload" /> 点击上传附件
                                </Button> </Upload> : <Upload
                                                    name="file"
                                                    action="https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"
                                                    onChange={this.handleChange}
                                                    beforeUpload={this.beforeUpload}
                                                    fileList={this.state.fileList}
                                                    headers={head}
                                                >
                                                <Button ><Icon type="upload" /> 点击上传附件</Button> </Upload>)

                                            //            <Upload
                                            //                name="file"
                                            //                action="https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"
                                            //                onChange={this.handleChange}
                                            //                beforeUpload={this.beforeUpload}
                                            //                fileList={this.state.fileList}
                                            //                headers={head}
                                            //            >
                                            //                {(this.state.fileList != null && this.state.fileList.length >= 4) ? <Button disabled>
                                            //                    <Icon type="upload" /> 点击上传附件
                                            //</Button> : <Button>
                                            //                        <Icon type="upload" /> 点击上传附件
                                            //</Button>}
                                            //            </Upload>
                                            //            )
                                        }
                                    </FormItem>
                                </Col>
                            </Row>
                            <p className='Ltitle' style={{ marginLeft: 20 }}>短信回复</p>
                            <Row>
                                <Col span={12}>
                                    <FormItem
                                        label="短信通知"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('info', {
                                            initialValue: "是",
                                            rules: [{ required: true }],
                                        }
                                        )(
                                            <Select size="default"
                                                placeholder="请选择"
                                                onChange={(value) => this.onOptionChange2(value)}>
                                                <Option value="是">是</Option>
                                                <Option value="否">否</Option>
                                            </Select>
                                            )}
                                    </FormItem>
                                </Col>
                                <Col span={2}>
                                    <Tooltip title='选择"是"并填写相应的短信内容，系统将自动发送短信通知消费者' arrowPointAtCenter={true}>
                                        <Icon type='question-circle-o' onClick={this.Pclick} style={{ marginLeft: "8px", marginTop: 10 }} />
                                    </Tooltip>
                                </Col>
                            </Row>
                            <Row style={{ marginLeft: "-35px" }}>
                                <Col span={24}>
                                    <FormItem
                                        label="短信内容"
                                        {...formItemLayout1}
                                        style={{ display: this.state.isShow }}
                                    >
                                        {getFieldDecorator('infoMessage', { rules: [{ required: this.state.True, message: '请输入需要发送的短信内容' }], }
                                        )(
                                            <TextArea autosize={{ minRows: 6, maxRows: 8 }} size='small' placeholder='请输入需要发送的短信内容,120字以内。' maxLength='120' />
                                            )}
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </Col>

                    <div className='Lcompanybtn1'   >
                        <Button type='primary' style={{ marginRight: 20 }} htmlType="submit" onClick={this.handleSubmit} disabled={this.state.disabled} >确定</Button>
                        <Button onClick={this.returnPrv}>返回列表</Button>
                    </div>

                </Row>
            </div >
        )
    }
}
const AppWrapped = Form.create()(App);

export default AppWrapped


// WEBPACK FOOTER //
// ./src/components/Content/Business/Compromise/CompormiseTransact/CompormiseTransact.js